<!--title -->
<app-modal-title
  [title]="formPageConfig.title | translate"
  [isShowClose]="true"
  (isCloseModal)="onClose()"
></app-modal-title>

<div mat-dialog-content class="dialog-content">
  <!-- form -->
  <form [formGroup]="form" autocomplete="off">
    <div class="tw-flex-center flex-column">
      <!-- senderNumberId -->
      <div class="tw-w-[300px]">
        <private-number-select-search
          class="tw-w-full"
          label="common.senderNumberId"
          [sendType]="SendTypes.P2P"
          [useType]="UseTypes.Normal"
          [isShowRefreshBtn]="true"
          [control]="form?.get('senderNumberId')"
          [(value)]="model.privateNumberId"
          (itemChange)="isCanSendFlashSms = $event?.isCanSendFlashSms"
        >
        </private-number-select-search>
      </div>

      <!-- date time picker -->
      <div class="tw-w-[300px]">
        <app-date-time-picker
          class="tw-mt-3 tw-w-full"
          [config]="directDateTimeConfig"
          (dateTime)="model.dateTimeNext = $event"
        >
        </app-date-time-picker>
      </div>

      <!-- description -->
      <form-textarea
        class="tw-w-full tw-mt-1"
        label="common.description"
        [(value)]="model.description"
        [control]="form?.get('description')"
        [rows]="1"
      >
      </form-textarea>
      <!-- isFlashSms -->
      <div
        class="checkbox-section tw-mr-[5px] ltr:tw-ml-[5px] tw-mb-[10px] tw-mt-2"
        *ngIf="isCanSendFlashSms"
      >
        <mat-slide-toggle
          [(ngModel)]="model.isFlashSms"
          formControlName="isFlashSms"
        >
          {{ "common.isFlashSms" | translate }}
        </mat-slide-toggle>
      </div>
    </div>

    <!-- submit btn -->
    <button
      type="button"
      (click)="onSubmit()"
      mat-ripple
      class="btn tw-w-full tw-mt-3 button-shadow btn-hover-rise"
      [disabled]="loading"
      [themeColor]="'btn'"
    >
      <ng-container *ngIf="!loading">
        <span>{{ "common.edit" | translate }}</span>
      </ng-container>

      <!-- loading -->
      <ng-container *ngIf="loading">
        <span
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>
        <span class="sr-only">Loading...</span>
      </ng-container>
    </button>
  </form>
</div>
